import {createContext, useContext} from 'react';
import {_clientUserStorage} from "../utils/storage";

const user = _clientUserStorage.get() || {}
const AgencyContext = createContext(user.agency_id)

//only read
export const useAgencyContext = () => useContext(AgencyContext) //equal AgencyContext.Consumer

export default AgencyContext;